import React, { createContext, useState } from 'react';
// import { hot } from 'react-hot-loader/root';
import { Router, Switch } from 'react-router';
import { QueryClient, QueryClientProvider } from 'react-query';
import BasicLayout from './pages/layout/BasicLayout';
import { history } from './utils/history';

const queryClient = new QueryClient();

export const FilterContext = createContext({});

const App = () => {

  const defaultPagination = { page: 0, size: 10 }
  const [objectFilters, setObjectFilters] = useState({ ...defaultPagination });
  const [conditionFilters, setConditionFilters] = useState({ ...defaultPagination });
  const [curatorialFilters, setCuratorialFilters] = useState({ ...defaultPagination });
  const [technicalFilters, setTechnicalFilters] = useState({ ...defaultPagination });
  const [movementFilters, setMovementFilters] = useState({ ...defaultPagination });
  const [treatmentFilters, setTreatmentFilters] = useState({ ...defaultPagination });
  const [insuranceFilters, setInsuranceFilters] = useState({ ...defaultPagination });

  return (
    <QueryClientProvider client={queryClient}>
      <FilterContext.Provider value={{
        objectFilters,
        setObjectFilters,
        conditionFilters,
        setConditionFilters,
        curatorialFilters,
        setCuratorialFilters,
        technicalFilters,
        setTechnicalFilters,
        movementFilters,
        setMovementFilters,
        treatmentFilters,
        setTreatmentFilters,
        insuranceFilters,
        setInsuranceFilters,
      }}>
        <Router history={history}>
          <Switch>
            <BasicLayout />
          </Switch>
        </Router>
      </FilterContext.Provider>
    </QueryClientProvider>
  );
};

export default App;
